// @ts-nocheck
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import { ButtonPresentationProps } from "@insite/mobius/Button";
import { LinkPresentationProps } from "@insite/mobius/Link";
import { useHistory } from "@insite/mobius/utilities/HistoryContext";
import constants from "@store/constants";
import QuickOrderFill from "@store/Library/Components/Toolkit/Icons/QuickOrder/QuickOrderFill";
import OrderActionSet, {
    orderActionSetFieldDefinitions,
    OrderActionSetPresentationProps,
} from "@store/Library/Components/Toolkit/Order/OrderActionSet";
import useExpandProps, { ExpandStyles } from "@toolkit/Framework/Common/Hooks/useExpandProps";
import { usePageLinkByPageType } from "@toolkit/Framework/Store/Links/LinksHooks";
import React from "react";

const enum fields {
    showOrderUpload = "showOrderUpload",
}

export interface OrderUploadActionsPresentationProps extends ExpandStyles<OrderUploadActionsStyles> {}

export interface OrderUploadActionsProps extends OrderUploadActionsPresentationProps, WidgetProps {
    fields: {
        [fields.showOrderUpload]?: boolean;
    };
}

export interface OrderUploadActionsStyles {
    actionSet?: OrderActionSetPresentationProps;
    quickOrderLink?: LinkPresentationProps;
    quickOrderButton?: ButtonPresentationProps;
}

export const orderUploadActionsStyles: OrderUploadActionsStyles = {
    quickOrderLink: { icon: { iconProps: { src: QuickOrderFill } } },
    quickOrderButton: { variant: "tertiary" },
};

const OrderUploadActions = ({ fields: widgetFields, extendedStyles, overridedStyles }: OrderUploadActionsProps) => {
    const styles = useExpandProps(orderUploadActionsStyles, extendedStyles, overridedStyles);
    const quickOrderLink = usePageLinkByPageType(constants.pageType.quickOrder);
    const history = useHistory();

    const clickHandler = () => {
        quickOrderLink && history.push(quickOrderLink.url);
    };

    return (
        <OrderActionSet
            {...styles.actionSet}
            fields={widgetFields}
            actions={[
                {
                    key: "quick",
                    label: translate("Quick Order"),
                    linkStyles: styles.quickOrderLink,
                    buttonStyles: styles.quickOrderButton,
                    testSelector: "uploadOrder_quickOrder",
                    href: quickOrderLink?.url,
                    onClick: clickHandler,
                    field: fields.showOrderUpload,
                },
            ]}
        />
    );
};

const widgetModule: WidgetModule = {
    component: OrderUploadActions,
    definition: {
        group: "Order Upload",
        allowedContexts: ["OrderUploadPage"],
        displayName: "Actions",
        fieldDefinitions: orderActionSetFieldDefinitions([{ name: fields.showOrderUpload, defaultState: "sticky" }]),
    },
};

export default widgetModule;
